import { SvgXml } from "react-native-svg";
export const CalendarIcon = ({ size = 14, color = "#000", secondaryColor, highlightedDay, }) => {
    /**
     * Determines the fill color for each day cell in the calendar icon.
     * The icon contains six day cells, each represented by a path with a unique index (0-5).
     * The `highlightedDay` prop is a 1-based day number (e.g., 1 for the first day).
     * To map `highlightedDay` to the correct path index, we use `(highlightedDay - 1) % 6`.
     * This allows highlighting the appropriate cell, cycling through the six available cells.
     * If the current path index matches the calculated highlighted index, it uses the primary color;
     * otherwise, it uses the secondary color.
     */
    const getPathColor = (pathIndex) => {
        if (secondaryColor && highlightedDay !== undefined) {
            const highlightedPathIndex = (highlightedDay - 1) % 6;
            return pathIndex === highlightedPathIndex ? color : secondaryColor;
        }
        return color;
    };
    const xml = `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18Z" fill="${String(color)}"/>
<path d="M4 12H6V10H4V12Z" fill="${String(getPathColor(0))}"/>
<path d="M4 16H6V14H4V16Z" fill="${String(getPathColor(3))}"/>
<path d="M8 12H10V10H8V12Z" fill="${String(getPathColor(1))}"/>
<path d="M8 16H10V14H8V16Z" fill="${String(getPathColor(4))}"/>
<path d="M12 12H14V10H12V12Z" fill="${String(getPathColor(2))}"/>
<path d="M12 16H14V14H12V16Z" fill="${String(getPathColor(5))}"/>
</svg>`;
    return <SvgXml xml={xml} width={size} height={size} fill={color}/>;
};
//# sourceMappingURL=CalendarIcon.js.map